import { ICartProduct } from 'featureSliced/shared/store/generalTypes'

export enum TableStatuses {
  FREE = 'FREE',
  BUSY = 'BUSY',
  IN_USE = 'IN_USE',
  UNDEFINED = 'UNDEFINED',
}

export const initialState: ITable = {
  table: 0,
  tableStatus: TableStatuses.UNDEFINED,
  isTableDataLoaded: false,
  isTableLoading: false,
  cloudItems: [],
  cloudTotal: 0,
  modVer: 0,
}

export interface ITable {
  table: number | string
  tableStatus: TableStatuses
  isTableDataLoaded: boolean
  isTableLoading: boolean
  cloudItems: ITableCloudItem[]
  cloudTotal: number
  modVer: number
  orderGuid?: string
}

export interface ITableCloudItem extends ICartProduct {
  categoryId: number
  count: number
  price: number
  productId: number
  menuItems: string

  kitchenFreeInfo: string
  discountP: number
  discountType: number
  guestId: number
  isManualCourse: number
  isRemoved: number
  itemGuid: string
  kitchenPrinted: number
  menuTotal: number
  originalPrice: number
  redeemPoints: number
  taxCode: number
  total: number
  isApplyDiscount?: boolean
}

export interface ITableCloudItemGroupped extends ITableCloudItem {
  uniqueId: string //
  itemGuids: string[] //
}
